import options from './battery-status.component';

export default {
    selector: 'dtBatteryStatus',
    options
};



// WEBPACK FOOTER //
// ./app/common/battery-status/index.js